import { useEffect, useMemo, useState } from 'react';
import debounce from 'debounce';
import { PendingRequestModal } from 'component/PendingRequestModal';
import { UnsavedDataModal } from '../UnsavedDataModal';

interface UnsavedOrPendingModalProps {
  showPending: boolean;
  showUnsaved?: boolean;
  onCancel: (() => void) | undefined;
  onConfirm: (() => void) | undefined;
}

const DEBOUNCE_DELAY_MS = 120;

export const UnsavedOrPendingModal = ({
  showPending: currentShowPending,
  showUnsaved: currentShowUnsaved = false,
  onCancel,
  onConfirm,
}: UnsavedOrPendingModalProps) => {
  const [showUnsaved, setShowUnsaved] = useState(currentShowUnsaved);
  const [showPending, setShowPending] = useState(currentShowPending);
  const debouncedSetShowUnsaved = useMemo(() => debounce(setShowUnsaved, DEBOUNCE_DELAY_MS), []);
  const debouncedSetShowPending = useMemo(() => debounce(setShowPending, DEBOUNCE_DELAY_MS), []);
  useEffect(() => {
    debouncedSetShowUnsaved(currentShowUnsaved);
  }, [debouncedSetShowUnsaved, currentShowUnsaved]);

  useEffect(() => {
    debouncedSetShowPending(currentShowPending);
  }, [debouncedSetShowPending, currentShowPending]);
  return (
    <>
      <UnsavedDataModal onCancel={onCancel} onConfirm={onConfirm} showModal={!!showUnsaved} />
      <PendingRequestModal visible={showPending} subscribeOnModalClose={onCancel} />
    </>
  );
};
